<template>
  <div class="mobile-app-panel right">
    <userInfo></userInfo>
    <div class="currency-info" v-if="user.bonus_id > 0">
        <slot v-for="(data, provider) in user.active_bonus.remaining">
            <slot v-if="data.data.is_active">
                <div class="label" :key="provider">
                    <span class="provider" :style="data.data.circuit != 0 ? 'margin-top: -4px;' : ''">{{ provider | ucFirst }}: 
                      <div class="progressbar" v-show="data.data.circuit != 0">
                      <div :style="'width: ' + data.x_percent + '%'" class="line"></div></div>
                    </span>
                    <b class="currency" v-show="data.data.circuit != 0">{{ data.remaining }} {{ user.currency }}</b>
                    <b class="currency" v-show="data.data.circuit == 0">{{ $t('app.not_included') }}</b>
                </div>
            </slot>
            <slot v-if="!data.data.is_active">
                <div class="label deactivated" :key="provider">
                    <span class="provider">{{ provider | ucFirst }}: </span>
                    <b class="currency">-</b>
                </div>
            </slot>
        </slot>
    </div>
    <slot v-else>
      <div class="currency-info-label" v-if="user.user_reserve > 0">
        <span>Ana kasa çevrimi:</span>
        <b>{{ user.user_reserve }} {{ user.currency }}</b>
      </div>
    </slot>
    <UserMenu @click.native="triggerPanel(false)" />
    <div class="row buttons" @click="triggerPanel(false)" style="padding:10px 0;margin-top:5px">
        <div class="col">
          <a :href="!_.isUndefined(social.livechat_mobile) ? social.livechat_mobile : ''" target="_blank" class="button default plain">Canlı Destek</a>
        </div>
        <div class="col">
          <a v-show="!_.isUndefined(social.whatsapp) && !_.isEmpty(social.whatsapp)" :href="'whatsapp://send?phone=+' + (!_.isUndefined(social.whatsapp) ? social.whatsapp : '')" class="button default plain">Whatsapp</a>
        </div>
    </div>
  </div>
</template>
<script>
  import UserMenu from '../User/UserMenu'
  import userInfo from '../userInfo'
  export default{
    components:{
      UserMenu,
      userInfo
    },
		methods:{
				triggerPanel(panel){
					this.$emit('triggerPanel', panel)
				}
		},
    computed:{
        social: function() {
            return this.$store.getters.getClientContent;
        },
        user(){
          return this.$user();
        },
        user_detail(){
          return this.$user_detail();
        }
    }
  }
</script>